import PropTypes from 'prop-types';
import courseRunShape from './courseRunShape';

const courseShape = {
  enrollmentCount: PropTypes.number.isRequired,
  uuid: PropTypes.string,
  title: PropTypes.string,
  shortDescription: PropTypes.string,
  strippedShortDescription: PropTypes.string,
  facts: PropTypes.arrayOf(PropTypes.string),
  setApart: PropTypes.arrayOf(PropTypes.shape({
    header: PropTypes.string,
    description: PropTypes.string,
  })),
  activeCourseRun: PropTypes.shape(courseRunShape),
  image: PropTypes.shape({
    src: PropTypes.string,
  }),
  originalImage: PropTypes.shape({
    src: PropTypes.string,
  }),
  isSelfPaced: PropTypes.bool,
  isFreeOption: PropTypes.bool,
  primarySubject: PropTypes.shape({
    name: PropTypes.string,
    slug: PropTypes.string,
  }),
  subjects: PropTypes.arrayOf(PropTypes.shape()),
  collaborators: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    image: PropTypes.shape({
      url: PropTypes.string,
    }),
  })),
  curriculumRaw: PropTypes.string,
  enrollButtonLink: PropTypes.string,
  leadCaptureFormUrl: PropTypes.string,
  organizationLogoOverrideUrl: PropTypes.string,
  organizationShortCodeOverride: PropTypes.string,
};

export default courseShape;
